angular
  .module('company')

  .controller('CompanyProjects24hCtrl', [
    '$scope',
    '$controller',
    '$timeout',
    '$state',
    '$filter',
    'CompanyStore',
    'Company24hCrud',
    'Confirm',
    'Dialog',
    'Company24hUtils',

    function(
      $scope,
      $controller,
      $timeout,
      $state,
      $filter,
      CompanyStore,
      Company24hCrud,
      Confirm,
      Dialog,
      Company24hUtils
    ) {
      $scope.languagesSummary = Company24hUtils.generateLanguagesSummary;
      $scope.editable = [];
      $scope.notes = [];
      $scope.titles = [];
      let companyId;

      CompanyStore.listenTo((company = {}) => {
        const { _id, workflows24h = [] } = company;
        companyId = _id;
        $scope.workflows24h = workflows24h;
      });

      $scope.delete = (workflow, index) => {
        const confirm = new Confirm();
        const message = $filter('translate')('company.DELETE_24H_PROJECT');
        confirm
          .show(message)
          .then(() => {
            const crud = new Company24hCrud(companyId);
            return crud.delete(workflow);
          })
          .then(() => {
            $scope.workflows24h.splice(index, 1);
          });
      };

      $scope.edit = (workflow, index) => {
        $scope.editable[index] = true;
      };

      $scope.save = (workflow, index) => {
        const crud = new Company24hCrud(companyId);
        const update = {
          _id: workflow._id,
          title: $scope.titles[index],
          notes: $scope.notes[index]
        };
        crud
          .update(update)
          .then(({ error } = {}) => {
            if (error) return Promise.reject(error);
            workflow.title = update.title;
            workflow.templateNotes = update.notes;
            $scope.editable[index] = false;
          })
          .catch(error => new Dialog().error(error));
      };
    }
  ]);
